module.exports = __webpack_public_path__ + "img/clip.603b84f3.png";